import {
  components,
  useTranslation
} from 'cng-web-lib'

import CompanyShipperRequestTypeFormProperties from './CompanyShipperRequestTypeFormProperties'
import CompanyShipperRequestTypeApiUrls from 'src/apiUrls/CompanyShipperRequestTypeApiUrls'
import React from 'react'
import Namespace from 'src/constants/locale/Namespace'
import CompanyForShipperRequestKeys from 'src/constants/locale/key/CompanyForShipperRequest'


const {
  table: {
    CngServerModeDialogFormTable,
    useFetchCustomLookup
  }
} = components


function CompanyShipperRequestTypeCrudTable({
  showNotification,
  companyForShipperRequestId,
  isViewOnly = false
}) {
  const { translate } = useTranslation([Namespace.COMPANY_FOR_SHIPPER_REQUEST])
  const translatedTextsObject = makeTranslatedTextsObject()
  const fetchCustomLookup = useFetchCustomLookup();

  let create = { url: CompanyShipperRequestTypeApiUrls.POST }
  let update = { url: CompanyShipperRequestTypeApiUrls.PUT }
  let del = { url: CompanyShipperRequestTypeApiUrls.DELETE }
  if (isViewOnly) {
    create = undefined
    update = undefined
    del = undefined
  }

  function makeTranslatedTextsObject() {
    let shpReqTypeId = translate(
      Namespace.COMPANY_FOR_SHIPPER_REQUEST,
      CompanyForShipperRequestKeys.CompanyShipperRequestType.SHP_REQ_TYPE_ID
    )

    return {
      shpReqTypeId
    }
  }

  const columns = [
    {
      field: 'shpReqTypeId',
      title: translatedTextsObject.shpReqTypeId,
      customLookup: () => {
        return fetchCustomLookup(
          `${process.env.REACT_APP_COMMON_SERVICE_ORIGIN_URL}/account-setup/shipper-request-type/hdr/get`,
          { },
          'content',
          'requestType',
          'id',
          (error) => console.error(error)
        )
      }
    }
  ]

  return (
    <CngServerModeDialogFormTable
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      disabled={isViewOnly}
      showNotification={showNotification}
      tableColumns={columns}
      formProperties={{
        ...CompanyShipperRequestTypeFormProperties,
        formikProps: {
          ...CompanyShipperRequestTypeFormProperties.formikProps,
          initialValues: {
            ...CompanyShipperRequestTypeFormProperties.formikProps.initialValues,
            companyForShipperRequestId: companyForShipperRequestId
          }
        }
      }}
      toClientDataFormat={(serverData) => {
        return serverData;
      }}
      toServerDataFormat={(localDatum) => {
        return localDatum;
      }}
      fetch={{
        url: CompanyShipperRequestTypeApiUrls.GET,
        body: {
          companyForShipperRequestId: companyForShipperRequestId
        }
      }}
      create={create}
      update={update}
      del={del}
      idAccessor='id'
    // tableConfigurationCode=''
    />
  )
}

export default CompanyShipperRequestTypeCrudTable
